/**
 * Menu registry — signing/NDA (B✕): sidebar and hamburger-menu entries for the
 * signing/NDA module, which is NOT part of the Dyrejournal build (decision
 * 2026-07-05, manifest §9). The consumers (sidebarDefaults.js, menu/index.js)
 * keep every entry's exact position via key lookups, so menu ORDER is
 * unchanged in the full build. The Dyrejournal-repo export replaces this file
 * with an empty stub (`export const sidebarItemsSigning = []; export const
 * menuItemsSigning = {};`) and the lookups filter out cleanly.
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */
import { h } from 'preact';
import { Text } from 'preact-i18n';

export const sidebarItemsSigning = [
    { key: 'signing-requests', category: 'utility', icon: 'fa-duotone fa-signature', label: 'Signing requests',
      action: 'route', href: '/signing-requests',
      isVisible: ({ user, currentCustomer }) => !!user.id && !currentCustomer?.menuItems?.hideSigning },
    { key: 'signRequest', category: 'utility', icon: 'fa-duotone fa-file-signature', label: 'Signing',
      action: 'route', href: '/signrequest', keyShortCut: 's r',
      isVisible: ({ user, currentCustomer }) => !!user.id && !currentCustomer?.menuItems?.hideSigning },
];

// Factories receiving a gate context ({ user }) because menu/index.js computes
// hasToBeAdmin eagerly at construction — same contract as menuItemsOther.
export const menuItemsSigning = {
    nda: () => ({ hasToBeAdmin: true, name: <Text id='menu.nda'>NDA Management</Text>, searchText: 'NDA Management Agreements Non-Disclosure', href: '/admin/nda', icon: 'fa-solid fa-file-contract', keyShortCut: 'a n' }),
    'signing-requests': ({ user }) => ({ hasToBeAdmin: !user.id, name: <Text id='menu.signing-requests'>Signing requests</Text>, searchText: 'Signing requests politiskjema signatur signing', href: '/signing-requests', icon: 'fa-duotone fa-signature' }),
    signRequest: ({ user }) => ({ hasToBeAdmin: !user.id, name: <Text id='menu.signRequest'>Signing</Text>, searchText: 'Signing document signature signering dokument elektronisk signatur', href: '/signrequest', icon: 'fa-duotone fa-file-signature', keyShortCut: 's r' }),
};
